import {
  GET_ADMIN_CHANGE_HISTORY,
  GET_ADMIN_CHANGE_HISTORY_SUCCESS,
  GET_ADMIN_CHANGE_HISTORY_ERROR,
  GET_ADMIN_CHANGE_HISTORY_EXPORT,
  GET_ADMIN_CHANGE_HISTORY_EXPORT_SUCCESS,
  GET_ADMIN_CHANGE_HISTORY_EXPORT_ERROR,
} from './actionTypes';
import { handleGetChangeHistory, handleGetChangeHistoryError, handleGetChangeHistorySuccess } from 'helpers/change_history_pagination_helper';

const initialState = {
  admin_change_history: [],
  loading: false,
  error: null,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  last_start_date: null,
  last_end_date: null,
  has_next_page: false,
  admin_history_export_loading: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  last_fetched_at: null,
};

const AdminChangeHistory = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_CHANGE_HISTORY:
      return handleGetChangeHistory(state, action, {
        dataKey: 'admin_change_history',
      });

    case GET_ADMIN_CHANGE_HISTORY_SUCCESS:
      return handleGetChangeHistorySuccess(state, action, {
        dataKey: 'admin_change_history',
      });

    case GET_ADMIN_CHANGE_HISTORY_ERROR:
      return handleGetChangeHistoryError(state, action);

    case GET_ADMIN_CHANGE_HISTORY_EXPORT:
      return {
        ...state,
        admin_history_export_loading: true,
      };

    case GET_ADMIN_CHANGE_HISTORY_EXPORT_SUCCESS:
      return {
        ...state,
        admin_history_export_loading: false,
      };

    case GET_ADMIN_CHANGE_HISTORY_EXPORT_ERROR:
      return {
        ...state,
        admin_history_export_loading: false,
      };

    default:
      return state;
  }
};

export default AdminChangeHistory;
